module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#health",
      toString: function () {
        return this.url;
      }
    }